export default __webpack_public_path__ + "locales/ar-SA/Translations.json?hash=3d66c656d2a91171fbc69fbe1431a1b4";